import createModel, {
  Mapped,
  Optional,
  Silent,
} from "@/__main__/data-model.mjs";

const apiModelValidation = createModel({
  ...Mapped({
    key: String,
    value: {
      apiKey: String,
      description: Optional(String),
      name: String,
      bonuses: [
        {
          needed: Number,
          effect: String,
        },
      ],
      scriptData: Silent({
        IsPVEAllowed: Boolean,
        IsStacking: Boolean,
        MaxStage: Number,
        MinStage: Number,
        Weight: Number,
      }),
    },
  }),
});

function transform(data) {
  return apiModelValidation(data);
}

export default transform;

export type TftPowerups = ReturnType<typeof transform>;
